import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { cur } from '@/lib/currency';

function KpiCard({ label, value, sub, color = 'default', progress, onClick }) {
  const colorMap = {
    default: 'bg-card border-border',
    red: 'bg-red-50 border-red-200',
    green: 'bg-emerald-50 border-emerald-200',
    blue: 'bg-blue-50 border-blue-200',
    amber: 'bg-amber-50 border-amber-200',
  };
  const textColor = {
    default: 'text-foreground',
    red: 'text-red-700',
    green: 'text-emerald-700',
    blue: 'text-primary',
    amber: 'text-amber-700',
  };
  return (
    <div
      onClick={onClick}
      className={`rounded-2xl border p-3 flex flex-col gap-1 relative transition-all duration-200
        ${colorMap[color]}
        ${onClick ? 'cursor-pointer hover:shadow-md hover:-translate-y-0.5 active:scale-[0.98] hover:border-primary/50' : ''}`}
    >
      {onClick && <ChevronLeft className="absolute top-2 left-2 w-3 h-3 text-primary opacity-40" />}
      <p className="text-xs text-muted-foreground font-medium leading-tight">{label}</p>
      <p className={`text-base font-bold leading-tight ${textColor[color]}`}>{value}</p>
      {progress !== undefined && (
        <div className="w-full bg-muted rounded-full h-1.5 mt-1">
          <div className="h-1.5 rounded-full bg-primary transition-all" style={{ width: `${Math.min(100, progress)}%` }} />
        </div>
      )}
      {sub && <p className="text-xs text-muted-foreground leading-tight">{sub}</p>}
    </div>
  );
}

function fmtAmt(n) {
  if (!n && n !== 0) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}م`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}ك`;
  return Number(n).toLocaleString('ar-EG', { maximumFractionDigits: 0 });
}

export default function CustomerKpiStrip({ customer, ordersTotal, invoicingTotal }) {
  const navigate = useNavigate();
  const customerId = customer?.id;
  const debt = customer?.debit || 0;
  const credit = customer?.credit || 0;
  const creditLimit = customer?.credit_limit || 0;
  const usedPct = creditLimit > 0 ? Math.round((debt / creditLimit) * 100) : 0;

  return (
    <div className="grid grid-cols-2 gap-2">
      <KpiCard
        label="إجمالي المبيعات"
        value={`${fmtAmt(invoicingTotal || credit)} ${cur()}`}
        sub={ordersTotal ? `${ordersTotal} طلب` : undefined}
        color="blue"
        onClick={customerId ? () => navigate('/orders') : undefined}
      />
      <KpiCard
        label="المتأخرات"
        value={`${fmtAmt(debt)} ${cur()}`}
        sub={debt > 0 ? 'يحتاج تحصيل' : 'لا توجد متأخرات'}
        color={debt > 0 ? 'red' : 'green'}
        onClick={debt > 0 && customerId ? () => navigate('/collections') : undefined}
      />
      <KpiCard
        label="الرصيد الدائن"
        value={`${fmtAmt(credit)} ${cur()}`}
        color="green"
      />
      <KpiCard
        label="حد الائتمان"
        value={creditLimit > 0 ? `${fmtAmt(creditLimit)} ${cur()}` : 'غير محدد'}
        sub={creditLimit > 0 ? `مُستخدم ${usedPct}%` : undefined}
        progress={creditLimit > 0 ? usedPct : undefined}
        color={usedPct > 80 ? 'amber' : 'default'}
      />
    </div>
  );
}